import { FlagKeys } from '@bettermode/flags/registry'

import { useFlag } from '../FlagsProvider.js'

export function useToggyModerateBannerEnabled(): boolean {
  return useFlag(FlagKeys.ToggyModerateBannerEnabled)
}
